export const capitalizeFirstLetter = (str)=> {
    if (!str) return ''; // Handle empty strings or null values
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }